<template>
<div class="checklistPage">
  <div class="ui loader" :class="{active: !loaded}" style="top: 30%;"></div>
  <template v-if="loaded">
    <template v-if="shops.length > 0">
      <div class="checklistPage__headerContainer">
        <h2 class="checklistPage__title">まとめてお問い合わせリスト</h2>
        <p class="checklistPage__titleDescription">以下のお店にまとめてお問い合わせをします</p>
      </div>
      <div class="checklistPage__headerControls">
        <div class="checklistPage__headerCounts">
          問い合わせリスト <span class="count">{{ $root.selectedShopCount }}</span> 件
        </div>
        <marunage-button button-class="big red" :bulk="true" :disabled="$root.selectedShopCount === 0" form-name-prefix="header_marunage_button_">まとめて問い合わせ</marunage-button>
      </div>

      <div class="checklistShops">
        <div v-for="shop in shops" :key="shop.id" class="checklistShops__shop">
          <div class="checklistShops__shopHeader">
            <a :href="shop.detail_url" class="title">{{ shop.name }}</a>
            <div class="checklistShops__multipleLike">
              <shop-checkbox :shop-id="shop.id"></shop-checkbox>
            </div>
          </div>
          <div class="checklistShops__shopBody">
            <div class="checklistShops__shopInfo">
              <div class="checklistShops__shopImage" :style="'background-image: url(' + shop.main_image.urls.medium + ');'"></div>
              <ul class="checklistShops__shopData">
                <li class="checklistShops__access">
                  <span class="checklistShops__subwayIcon">
                    <i class="fas fa-map-marker-alt"></i>
                  </span>
                  {{ shop.access }}
                </li>
                <li>
                  <span class="checklistShops__shopDataLabel">最大人数</span>
                  <span class="checklistShops__shopDataContent">
                    立席：<span v-if="shop.max_standing_count">{{ shop.max_standing_count }}</span><span v-else>--</span>人
                    /
                    着席：<span v-if="shop.max_count">{{ shop.max_count }}</span><span v-else>--</span>人
                  </span>
                </li>
                <li>
                  <span class="checklistShops__shopDataLabel">予算</span>
                  <span class="checklistShops__shopDataContent">{{ lowestPriceLabel(shop.courses) }}</span>
                </li>
                <li>
                  <span class="checklistShops__shopDataLabel">ジャンル</span>
                  <span class="checklistShops__shopDataContent"><span v-for="genre in shop.genre_labels">{{ genre.label }}&nbsp;&nbsp;</span></span>
                </li>
              </ul>
            </div>
            <div class="checklistShops__shopDescription">
              <p>{{ shop.title }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="checklistPage__footerControls">
        <div class="checklistPage__footerCounts">
          問い合わせリスト <span class="count">{{ $root.selectedShopCount }}</span> 件
        </div>

        <marunage-button button-class="big red" :bulk="true" :disabled="$root.selectedShopCount === 0" form-name-prefix="footer_marunage_button_">まとめて問い合わせ</marunage-button>
      </div>
    </template>

    <div v-else class="checklistPageBlank">
      <p class="checklistPageBlank__text">問い合わせリストにお店がありません。</p>
      <a href="/">グルメプラスTOPへ</a>
    </div>
  </template>
</div>
</template>

<script>
import ShopCheckbox from './shopCheckbox.vue';
import MarunageButton from './marunageButton.vue';

export default {
    components: {
        'shop-checkbox': ShopCheckbox,
        'marunage-button': MarunageButton
    },
    data: function() {
        return {
            loaded: false,
            shops: []
        };
    },
    created: function() {
        Promise.all(this.selectedShops().map(function(shopId) {
            return this.createForm().get('/api/shops/' + shopId, function(response) {
                this.shops.push(response.data);
            }.bind(this));
        }.bind(this))).then(function() {
            this.loaded = true;
        }.bind(this));
    },
    methods: {
        lowestPriceLabel: function(courses) {
            if (courses.length === 0) {
                return 'お問い合わせください';
            }
            var lowestPriceCourse = _.sortBy(courses, function(course) {
                return course.discounted_price || course.price;
            })[0];
            var label = '';
            if (lowestPriceCourse.drink_type_label) {
                label = lowestPriceCourse.drink_type_label;
            } else {
                label = '飲み放題なし';
            }
            label += ' ' + (lowestPriceCourse.discounted_price || lowestPriceCourse.price) + '円〜';
            return label;
        },
    }
};
</script>
